import _ from "lodash";
import {getFieldsByPath} from "../liberality/utils";
import {setFieldVisibility} from "../../../../apps/KpModule/actions";

export const entity = {
    name: 'Race',
    //facets: [{name: 'codeName', nameOptional: false, uniqueName: true}],
    fields: [
        {path: 'code', unique: true, uniqueWith: ['animalType']},
        {path: 'name', unique: true, uniqueWith: ['animalType']},
        {path: 'animalType', type: 'AnimalType'},
        {path: 'isCategorizedRace', type: 'boolean'},
        'adoptionConditions'
    ],
    filters: [
        {
            name: 'byAnimalType',
            path: "animalType",
            object: "AnimalType",
            isDefault: false,
            query: function (context) {
                const animalType = _.get(context, "data.animalType")

                return animalType
                    ? {animalType: new global.ObjectID(animalType.id)}
                    : {_id: null}
            }
        },
    ]
}

export const module_ = {
    object: 'Race',
    tKey: 'mTitle_race',
    defaultSortBy: 'animalType',
    defaultSortDirection: 'ASC',
    category: {
        path: 'mTitle_animals',
        icon: 'animal'
    },
    viewMap: {
        dt: [
            'code', 'name', 'animalType', 'isCategorizedRace'
        ],
        form: [
            {path: 'code', required: true},
            {path: 'name', required: true},
            'animalType',
            {
                path: 'isCategorizedRace',
                subscriptions: {
                    onChange: (newValue, oldValue, {store, module}) => {
                        const neededFormFields = getFieldsByPath(module.viewMap.form.fields, ['adoptionConditions']);
                        store.dispatch(setFieldVisibility(neededFormFields?.adoptionConditions.id, !!newValue))

                        const changedValue = typeof oldValue === 'boolean' && typeof newValue === 'boolean' && oldValue && !newValue
                        if (changedValue) neededFormFields?.adoptionConditions.setValue('')
                    }
                }
            },
            {path: 'adoptionConditions', type: 'textarea'}
        ]
    }
}
